var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"toast_popup",class:{ toast_popup_storage: _vm.isPopup }},[_c('p',{staticClass:"txt_popup"},[_vm._v(_vm._s(_vm.toastMessage))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }